import { Button, type IButtonProps } from '~/components/button'

type ButtonMicrophoneProps = Omit<IButtonProps, 'children'> & {
  testID?: string
}

export function ButtonMicrophone(props: ButtonMicrophoneProps) {
  return (
    <Button.Root
      {...props}
      size={props.size || 'md'}
      variant="neutral-tertiary"
    >
      <Button.Icon symbol="rdicon-microphone" />
    </Button.Root>
  )
}
